import * as firebase from 'firebase';

const firebaseConfig = {
    apiKey: "AIzaSyBtHwCV2gEHJnxDZZpLBvpjPS_CARIl2sA",
    authDomain: "kle-vuefire.firebaseapp.com",
    databaseURL: "https://kle-vuefire.firebaseio.com",
    projectId: "kle-vuefire",
    storageBucket: "kle-vuefire.appspot.com",
    messagingSenderId: "597365932768",
    appId: "1:597365932768:web:13def66afbadd14ef00685",
    measurementId: "G-6QR61B7V1E"
}

const firebaseApp = firebase.initializeApp(firebaseConfig);

export const db = firebaseApp.firestore();